import { initAppAnalytics } from "@hamdevco/analytics/app";
import '@hotwired/turbo-rails';
import.meta.glob('../channels/**/*_channel.js', { eager: true });

import '../utils/setupServiceWorker.js';
import '../utils/setupHoneybadger.js';
import '../utils/setupStimulus.js';

// PostHog for the authenticated product. Ingest is proxied same-origin at
// /ingest by IngestController. The token is a literal: a phc_ project key is
// public by design and must reach the browser either way.
initAppAnalytics({
  token: "phc_kiMDPA45nVkcBdtWEKFkyKWpipEKymrRibqaWkiyyMGc", // Client Sites (590740)
  app: "budsproduce",
  owner: "client",
  client: "budsproduce",
});
